import React from 'react';
import { FormControl, InputLabel, Select, MenuItem } from '@mui/material';

const CustomerFilter = ({ customers, selectedCustomer, onChange }) => {
  return (
    <FormControl fullWidth>
      <InputLabel id="customer-filter-label" shrink={true}>Customer</InputLabel>
      <Select
        labelId="customer-filter-label"
        id="customer-filter"
        value={selectedCustomer || ''}
        label="Customer"
        onChange={(e) => onChange(e.target.value)}
        displayEmpty
        renderValue={(value) => value ? customers.find(c => c.customer_id === value)?.name : "All Customers"}
      >
        <MenuItem value="">All Customers</MenuItem>
        {customers.map((customer) => (
          <MenuItem key={customer.customer_id} value={customer.customer_id}>
            {customer.name}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
};

export default CustomerFilter;
